const API_ENDPOINT = 'Departments'

export const API_DEPARTMENTS = {
  API_ENDPOINT,
  GET_ALL_DYNAMIC: `${API_ENDPOINT}/GetAllDynamic`,
  POST: `${API_ENDPOINT}/Create`,
  PATCH: (data: { id: Department['id'] }) =>  `${API_ENDPOINT}/Patch/${data.id}`,
  DELETE: (data: { id: Department['id'] }) => `${API_ENDPOINT}/Delete/${data.id}`,
}

export class Department {
  id!: string
  title: string = ''
  isActive: boolean = true
}
